import { Component, OnInit, Renderer2, Input } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { MatDialog, DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material';
import { AppDateAdapter, APP_DATE_FORMATS } from 'src/app/helpers/date-formats';
import { registerLocaleData, CommonModule } from '@angular/common';
import localeEs from '@angular/common/locales/es';
import localeEsExtra from '@angular/common/locales/extra/es';
import { StatsService } from 'src/app/core/services/stats.service';

registerLocaleData(localeEs, 'es-ES', localeEsExtra);

@Component({
  selector: 'app-docs-by-day',
  templateUrl: './docs-by-day.component.html',
  styleUrls: ['./docs-by-day.component.scss'],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'es-ES' },
    { provide: DateAdapter, useClass: AppDateAdapter },
    { provide: MAT_DATE_FORMATS, useValue: APP_DATE_FORMATS }
  ]
})
export class DocsByDayComponent {

  loading: boolean;
  mostrarListado: boolean;
  mostrarError: boolean;
  datosDocDias = []; 

  constructor( private statsService: StatsService ) {
    this.loading = false;
    this.mostrarListado = false;
    this.mostrarError = false;
    this.datosDocDias = [];
  }

  VisualizarDocumentos(usuarioPrincipal: string) {

    this.loading = true;
    this.mostrarError = false;
    this.mostrarListado = false;

    this.statsService.ObtenerListadoDocDia(usuarioPrincipal).subscribe(datos => {
      this.datosDocDias = datos;
      this.loading = false;
      this.mostrarListado = true;
    }, ( error ) => {
      this.loading = false;
      this.mostrarError = true;
    });
  }
}
